<template>
    <div id="optionen">
        <input type="checkbox" v-model="config.zeigeHinweise">Erläuterungen zeigen
        <input type="checkbox" v-model="config.zeigeJavaCode">Javacode zeigen
    </div>
</template>

<script>
    export default {
        name: 'optionen',
        props: ['config'],
    }
</script>

<style scoped>
    #optionen {
        background-color: #f5f5f5;
        padding: 10px;
        margin-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// Optionen.vue?3a1e965e